import { Injectable } from '@angular/core';
import { LogPublisher } from './log-publisher';
import { LoggerInterface } from './interfaces';
import { LogLevel } from './log-level';
import { LogEntry } from './log-entry';

@Injectable()
export class Logger implements LoggerInterface {
  level: LogLevel = LogLevel.DEBUG;
  publishers: LogPublisher[] = [];

  /**
   * @param level
   */
  setLevel(level: LogLevel | string): void {
    let logLevel: LogLevel;

    if (typeof level === 'string') {
      logLevel = LogLevel[level.toUpperCase()];
    } else {
      logLevel = level;
    }

    if (logLevel !== undefined) {
      this.level = logLevel;
    }
  }

  /**
   * Determines if logging should occur.
   *
   * @param level Level to be checked
   * @returns true if message should be logged
   */
  private shouldLog(level: LogLevel): boolean {
    return level <= this.level;
  }

  log(level: LogLevel, message: string, context?: any) {
    if (this.shouldLog(level)) {
      const entry: LogEntry = new LogEntry(level, message, context);

      for (const logger of this.publishers) {
        logger.log(entry);
      }
    }
  }

  emerg(message: string, context?: any): void {
    if (!this) {
      return;
    }
    this.log(LogLevel.EMERG, message, context);
  }

  alert(message: string, context?: any): void {
    if (!this) {
      return;
    }
    this.log(LogLevel.ALERT, message, context);
  }

  crit(message: string, context?: any): void {
    if (!this) {
      return;
    }
    this.log(LogLevel.CRIT, message, context);
  }

  error(message: string, context?: any): void {
    if (!this) {
      return;
    }
    this.log(LogLevel.ERROR, message, context);
  }

  warn(message: string, context?: any): void {
    if (!this) {
      return;
    }
    this.log(LogLevel.WARN, message, context);
  }

  notice(message: string, context?: any): void {
    if (!this) {
      return;
    }
    this.log(LogLevel.NOTICE, message, context);
  }

  info(message: string, context?: any): void {
    if (!this) {
      return;
    }
    this.log(LogLevel.INFO, message, context);
  }

  debug(message: string, context?: any): void {
    if (!this) {
      return;
    }
    this.log(LogLevel.DEBUG, message, context);
  }
}
